import { UserName } from "../../../Users/shared/UserName.js";
import { LocationName } from "../../../Locations/shared/LocationName.js";
import { LocationNames } from "../../../Locations/shared/LocationNames.js";
import { REFS_BY_TYPE_LABELS_MAP } from "../constants.js";
import { EventName } from "../../../Events/shared/EventName.js";
import { UserNames } from "../../../Users/shared/UserNames.js";
import { LocationLogEntryTitle } from "../../../Locations/shared/LocationLogEntries/LocationLogEntryTitle.js";
import { RecordTitle } from "../../../Records/shared/RecordTitle.js";
import { ReportTitle } from "../../../Reports/shared/ReportTitle.js";
import { EventNames } from "../../../Events/shared/EventNames.js";
import { RecordTitles } from "../../../Records/shared/RecordTitles.js";
import { ReportTitles } from "../../../Reports/shared/ReportTitles.js";
import { LocationLogEntryTitles } from "../../../Locations/shared/LocationLogEntries/LocationLogEntryTitles.js";
import "react";
import { Tooltip } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/RefsByTypeTitles/components/RefsHorizontal.tsx
var typeComponents = {
	eventIds: (id) => /* @__PURE__ */ jsx(EventName, { id }, id),
	locationIds: (id) => /* @__PURE__ */ jsx(LocationName, { locationId: id }, id),
	locationLogEntryIds: (id) => /* @__PURE__ */ jsx(LocationLogEntryTitle, { id }, id),
	recordIds: (id) => /* @__PURE__ */ jsx(RecordTitle, { id }, id),
	reportIds: (id) => /* @__PURE__ */ jsx(ReportTitle, { id }, id),
	userIds: (id) => /* @__PURE__ */ jsx(UserName, { userId: id }, id)
};
var multiTypeComponents = {
	eventIds: (ids) => /* @__PURE__ */ jsx(EventNames, { eventIds: ids }),
	locationIds: (ids) => /* @__PURE__ */ jsx(LocationNames, { locationIds: ids }),
	locationLogEntryIds: (ids) => /* @__PURE__ */ jsx(LocationLogEntryTitles, { entryIds: ids }),
	recordIds: (ids) => /* @__PURE__ */ jsx(RecordTitles, { recordIds: ids }),
	reportIds: (ids) => /* @__PURE__ */ jsx(ReportTitles, { reportIds: ids }),
	userIds: (ids) => /* @__PURE__ */ jsx(UserNames, { userIds: ids })
};
function RefsHorizontal({ refsByType }) {
	return /* @__PURE__ */ jsx("div", {
		className: "-mx-xxs flex w-fit flex-wrap",
		children: Object.entries(refsByType).map(([type, ids]) => !!ids?.length && /* @__PURE__ */ jsxs("span", {
			className: "mx-xxs flex w-fit flex-nowrap",
			children: [
				/* @__PURE__ */ jsxs("span", {
					className: "font-medium",
					children: [REFS_BY_TYPE_LABELS_MAP[type].single, ":"]
				}),
				/* @__PURE__ */ jsx("span", {
					className: "ml-xxs",
					children: typeComponents[type](ids.at(-1))
				}),
				ids.length > 1 && /* @__PURE__ */ jsx(Tooltip, {
					tooltip: /* @__PURE__ */ jsx("div", {
						className: "flex flex-wrap",
						children: multiTypeComponents[type](ids)
					}),
					underline: true,
					children: /* @__PURE__ */ jsxs("span", {
						className: "ml-xxs text-info",
						children: ["+", ids.length - 1]
					})
				}),
				/* @__PURE__ */ jsx("span", { children: ";" })
			]
		}, type))
	});
}
//#endregion
export { RefsHorizontal };

//# sourceMappingURL=RefsHorizontal.js.map